import { ChainNetwork } from './networks'
import {
  getTokenContractsFor,
  TokenEnvironment,
  TokenLifecycle,
} from './tokenContracts'

export const getCadcContractAddress = ({
  env,
  network,
  lifecycle,
}: {
  env: TokenEnvironment
  network: ChainNetwork
  lifecycle: TokenLifecycle
}): string | undefined =>
  getTokenContractsFor({ env, network, symbol: 'CADC' }).find(
    (contract) => contract.lifecycle === lifecycle
  )?.address
